<template>
  <grid id="endDeviceLastGatewaysGrid"
        :title="$t('ed-lastGateways:lastGateways')"
        :columns="columns"
        :paginated-dto="rows"
        :pagination="false"
        :download-btn="false"
        compact
        @load="getGateways"
  >
    <router-link slot="eui" slot-scope="props" :to="{name: 'gatewayRoute', params: {eui: props.dto.eui}}">{{ props.dto.eui }}</router-link>
    <template slot="lastDate" slot-scope="props">{{ props.dto.lastDate | date }}</template>
  </grid>
</template>

<script>
import { isEmpty } from 'lodash-es'
import to from '@/modules/await-to-js'

export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      rows: {}
    }
  },

  computed: {
    columns () {
      return [
        { text: this.$t('ed-lastGateways:eui'), slot: 'eui' },
        { text: this.$t('ed-lastGateways:lastTimestamp'), slot: 'lastDate' }
      ]
    }
  },

  watch: {
    endDevice () {
      this.getGateways()
    }
  },

  created () {
    this.getGateways()
  },

  methods: {
    async getGateways () {
      if (isEmpty(this.endDevice)) return

      let error, response
      [error, response] = await to(this.$api.getEndDeviceLastGateways(this.endDevice, { page: 1, pageSize: 5, sort: '-lastDate' }))
      if (error || !response) return

      this.rows = response.data
    }
  }
}
</script>
